// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","trendsBlock":"hyDAn","links":"_2ZXF7","link":"_8cQux cXdS1 hRgdS"};